const NavLinks = [
  {
    title: 'Home',
    href: '/',
  },

  {
    title: 'About Us',
    href: '/about',
  },

  {
    title: 'Blogs',
    href: '/Blog',
  },
  

  {
    title: 'Contact Us',
    href: '/contact',
  },
  // {
  //   title: "Services",
  //   href: "/services",
  // },
] as const

export { NavLinks }
